import { render } from "./LabelPrintingPage.vue?vue&type=template&id=367e9d35"
import script from "./LabelPrintingPage.vue?vue&type=script&lang=js"
export * from "./LabelPrintingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__